import React from 'react';

const Pagination = ({
  currentPage,
  totalPages,
  startIndex,
  perPage,
  totalItems,
  onPageChange,
  onLimitChange,
  label = 'element'
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
      marginTop: '0.75rem',
      padding: '0.75rem',
      borderTop: '1px solid var(--border)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {/* Wybor liczby elementow na stronie */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '1rem' }}>
          <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Pokaz:</span>
          <select
            value={perPage}
            onChange={(e) => onLimitChange(parseInt(e.target.value))}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              backgroundColor: 'var(--card-bg)',
              color: 'var(--text)'
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        {/* Przycisk pierwsza strona */}
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          style={{
            padding: '4px 10px',
            fontSize: '11px',
            border: '1px solid var(--border)',
            backgroundColor: currentPage === 1 ? 'var(--bg)' : 'var(--card-bg)',
            color: currentPage === 1 ? 'var(--text-muted)' : 'var(--text-secondary)',
            cursor: currentPage === 1 ? 'not-allowed' : undefined
          }}
          title="Pierwsza strona"
        >
          &laquo;
        </button>

        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '4px 10px',
            fontSize: '11px',
            border: '1px solid var(--border)',
            backgroundColor: currentPage === 1 ? 'var(--bg)' : 'var(--card-bg)',
            color: currentPage === 1 ? 'var(--text-muted)' : 'var(--text)',
            cursor: currentPage === 1 ? 'not-allowed' : undefined
          }}
        >
          &larr; Poprzednia
        </button>

        {/* Numery stron */}
        {totalPages > 0 && (
          <div style={{ display: 'flex', gap: '2px' }}>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNum}
                  onClick={() => onPageChange(pageNum)}
                  style={{
                    padding: '4px 10px',
                    fontSize: '11px',
                    border: '1px solid var(--border)',
                    backgroundColor: currentPage === pageNum ? 'var(--primary)' : 'var(--card-bg)',
                    color: currentPage === pageNum ? '#fff' : 'var(--text)',
                    minWidth: '28px',
                    fontWeight: currentPage === pageNum ? '600' : '400'
                  }}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>
        )}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          style={{
            padding: '4px 10px',
            fontSize: '11px',
            border: '1px solid var(--border)',
            backgroundColor: currentPage === totalPages ? 'var(--bg)' : 'var(--card-bg)',
            color: currentPage === totalPages ? 'var(--text-muted)' : 'var(--text)',
            cursor: currentPage === totalPages ? 'not-allowed' : undefined
          }}
        >
          Nastepna &rarr;
        </button>

        {/* Przycisk ostatnia strona */}
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages || totalPages === 0}
          style={{
            padding: '4px 10px',
            fontSize: '11px',
            border: '1px solid var(--border)',
            backgroundColor: currentPage === totalPages ? 'var(--bg)' : 'var(--card-bg)',
            color: currentPage === totalPages ? 'var(--text-muted)' : 'var(--text-secondary)',
            cursor: currentPage === totalPages ? 'not-allowed' : undefined
          }}
          title="Ostatnia strona"
        >
          &raquo;
        </button>
      </div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
        Pokazuje {startIndex + 1} - {Math.min(startIndex + perPage, totalItems)} z {totalItems} {label}
      </div>
    </div>
  );
};

export default Pagination;
